<script setup lang="ts">
import { ref, computed, watch } from "vue";

const props = defineProps({
  modelValue: {
    type: Number,
  },
  inputClass: {
    type: String,
    default: 'form-control',
  },
});

const setFromValue = (value: number | undefined) => {
  const offsetSign = Object.is(value, -0) ? '-' : (value && value < 0 ? '-' : '+');
  let offsetDuration = Math.abs(value || 0);
  let offsetUnit = 'minutes';

  if (offsetDuration % 1440 === 0) {
    offsetDuration /= 1440;
    offsetUnit = 'days';
  } else if (offsetDuration % 60 === 0) {
    offsetDuration /= 60;
    offsetUnit = 'hours';
  }

  sign.value = offsetSign;
  duration.value = offsetDuration;
  unit.value = offsetUnit;
};

const sign = ref('+');
const duration = ref(0);
const unit = ref('minutes');
setFromValue(props.modelValue);

watch(() => props.modelValue, (value) => {
  setFromValue(value);
});

const unitFactors: Record<string, number> = {
  minutes: 1,
  hours: 60,
  days: 1440,
};

const offsetInMinutes = computed(() => {
  const factor = unitFactors[unit.value] || 1;
  let value = duration.value * factor;
  if (sign.value === '-') {
    value = -value;
  }
  // preserve -0 as a number
  console.log('value', value, Object.is(value, -0));
  return Object.is(value, -0) ? -0 : value;
});

const emit = defineEmits(['update:modelValue']);
watch(() => offsetInMinutes.value, (value) => {
  emit('update:modelValue', value);
});

const MAX_MINUTES = 525600;
</script>

<template>
  <div class="form-row align-items-center">
    <div class="col-3 col-md-auto">
      <select id="sign" :class="props.inputClass" v-model="sign">
        <option value="+">+</option>
        <option value="-">-</option>
      </select>
    </div>
    <div class="col-3 col-md-auto">
      <input
        id="duration"
        type="number"
        :class="props.inputClass"
        v-model.number="duration"
        :placeholder="$t('Duration')"
        min="0"
        :max="MAX_MINUTES"
      />
    </div>
    <div class="col-auto">
      <select id="unit" :class="props.inputClass" v-model="unit">
        <option value="minutes">{{ $t('Minutes') }}</option>
        <option value="hours">{{ $t('Hours') }}</option>
        <option value="days">{{ $t('Days') }}</option>
      </select>
    </div>
  </div>
</template>